export default "__VITE_ASSET__8ac05764__"